/* tslint:disable */
/* eslint-disable */
import { Injectable } from '@angular/core';
import { HttpClient, HttpResponse } from '@angular/common/http';
import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';
import { RequestBuilder } from '../request-builder';
import { Observable } from 'rxjs';
import { map, filter } from 'rxjs/operators';

import { DataSourceLoadOptionsBase } from '../models/data-source-load-options-base';
import { FermetureTemporaireDto } from '../models/fermeture-temporaire-dto';
import { LoadResult } from '../models/load-result';


/**
 * Fonctions de gestion des fermetures temporaires des recyparcs
 */
@Injectable({
  providedIn: 'root',
})
export class FermeturesTemporairesRecyparcsService extends BaseService {
  constructor(
    config: ApiConfiguration,
    http: HttpClient
  ) {
    super(config, http);
  }

  /**
   * Path part for operation fermetureTemporaireGetList
   */
  static readonly FermetureTemporaireGetListPath = '/api/fermetures-temporaires-recyparcs/list/{parcId}';

  /**
   * Renvoie la liste des fermetures temporaires du recyparc spécifié.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `fermetureTemporaireGetList()` instead.
   *
   * This method doesn't expect any request body.
   */
  fermetureTemporaireGetList$Response(params: {

    /**
     * Identifiant du recyparc
     */
    parcId: number;
  }): Observable<StrictHttpResponse<Array<FermetureTemporaireDto>>> {

    const rb = new RequestBuilder(this.rootUrl, FermeturesTemporairesRecyparcsService.FermetureTemporaireGetListPath, 'get');
    if (params) {
      rb.path('parcId', params.parcId, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Array<FermetureTemporaireDto>>;
      })
    );
  }

  /**
   * Renvoie la liste des fermetures temporaires du recyparc spécifié.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `fermetureTemporaireGetList$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  fermetureTemporaireGetList(params: {

    /**
     * Identifiant du recyparc
     */
    parcId: number;
  }): Observable<Array<FermetureTemporaireDto>> {

    return this.fermetureTemporaireGetList$Response(params).pipe(
      map((r: StrictHttpResponse<Array<FermetureTemporaireDto>>) => r.body as Array<FermetureTemporaireDto>)
    );
  }

  /**
   * Path part for operation fermetureTemporairePost
   */
  static readonly FermetureTemporairePostPath = '/api/fermetures-temporaires-recyparcs/{parcId}';

  /**
   * Crée une fermeture temporaire pour le recyparc spécifié.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `fermetureTemporairePost()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  fermetureTemporairePost$Response(params: {

    /**
     * Identifiant du recyparc
     */
    parcId: number;

    /**
     * Fermeture temporaire
     */
    body: FermetureTemporaireDto
  }): Observable<StrictHttpResponse<FermetureTemporaireDto>> {

    const rb = new RequestBuilder(this.rootUrl, FermeturesTemporairesRecyparcsService.FermetureTemporairePostPath, 'post');
    if (params) {
      rb.path('parcId', params.parcId, {});
      rb.body(params.body, 'application/json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<FermetureTemporaireDto>;
      })
    );
  }

  /**
   * Crée une fermeture temporaire pour le recyparc spécifié.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `fermetureTemporairePost$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  fermetureTemporairePost(params: {

    /**
     * Identifiant du recyparc
     */
    parcId: number;

    /**
     * Fermeture temporaire
     */
    body: FermetureTemporaireDto
  }): Observable<FermetureTemporaireDto> {

    return this.fermetureTemporairePost$Response(params).pipe(
      map((r: StrictHttpResponse<FermetureTemporaireDto>) => r.body as FermetureTemporaireDto)
    );
  }

  /**
   * Path part for operation fermetureTemporaireLoadList
   */
  static readonly FermetureTemporaireLoadListPath = '/api/fermetures-temporaires-recyparcs/load-list/{parcId}';

  /**
   * Renvoie la liste des fermetures temporaires du recyparc spécifié (avec support pour groupement, filtrage, pagination et tri).
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `fermetureTemporaireLoadList()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  fermetureTemporaireLoadList$Response(params: {

    /**
     * Identifiant du recyparc
     */
    parcId: number;

    /**
     * Paramètres de groupement, filtrage, pagination et tri
     */
    body: DataSourceLoadOptionsBase
  }): Observable<StrictHttpResponse<LoadResult>> {

    const rb = new RequestBuilder(this.rootUrl, FermeturesTemporairesRecyparcsService.FermetureTemporaireLoadListPath, 'post');
    if (params) {
      rb.path('parcId', params.parcId, {});
      rb.body(params.body, 'application/json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<LoadResult>;
      })
    );
  }

  /**
   * Renvoie la liste des fermetures temporaires du recyparc spécifié (avec support pour groupement, filtrage, pagination et tri).
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `fermetureTemporaireLoadList$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  fermetureTemporaireLoadList(params: {

    /**
     * Identifiant du recyparc
     */
    parcId: number;

    /**
     * Paramètres de groupement, filtrage, pagination et tri
     */
    body: DataSourceLoadOptionsBase
  }): Observable<LoadResult> {

    return this.fermetureTemporaireLoadList$Response(params).pipe(
      map((r: StrictHttpResponse<LoadResult>) => r.body as LoadResult)
    );
  }

  /**
   * Path part for operation fermetureTemporaireGet
   */
  static readonly FermetureTemporaireGetPath = '/api/fermetures-temporaires-recyparcs/{id}';

  /**
   * Renvoie la fermeture temporaire spécifiée.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `fermetureTemporaireGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  fermetureTemporaireGet$Response(params: {

    /**
     * Identifiant de la fermeture temporaire
     */
    id: number;
  }): Observable<StrictHttpResponse<FermetureTemporaireDto>> {

    const rb = new RequestBuilder(this.rootUrl, FermeturesTemporairesRecyparcsService.FermetureTemporaireGetPath, 'get');
    if (params) {
      rb.path('id', params.id, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<FermetureTemporaireDto>;
      })
    );
  }

  /**
   * Renvoie la fermeture temporaire spécifiée.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `fermetureTemporaireGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  fermetureTemporaireGet(params: {

    /**
     * Identifiant de la fermeture temporaire
     */
    id: number;
  }): Observable<FermetureTemporaireDto> {

    return this.fermetureTemporaireGet$Response(params).pipe(
      map((r: StrictHttpResponse<FermetureTemporaireDto>) => r.body as FermetureTemporaireDto)
    );
  }

  /**
   * Path part for operation fermetureTemporairePut
   */
  static readonly FermetureTemporairePutPath = '/api/fermetures-temporaires-recyparcs/{id}';

  /**
   * Met à jour la fermeture temporaire spécifiée.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `fermetureTemporairePut()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  fermetureTemporairePut$Response(params: {

    /**
     * Identifiant de la fermeture temporaire
     */
    id: number;

    /**
     * Fermeture temporaire
     */
    body: FermetureTemporaireDto
  }): Observable<StrictHttpResponse<FermetureTemporaireDto>> {

    const rb = new RequestBuilder(this.rootUrl, FermeturesTemporairesRecyparcsService.FermetureTemporairePutPath, 'put');
    if (params) {
      rb.path('id', params.id, {});
      rb.body(params.body, 'application/json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<FermetureTemporaireDto>;
      })
    );
  }

  /**
   * Met à jour la fermeture temporaire spécifiée.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `fermetureTemporairePut$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  fermetureTemporairePut(params: {

    /**
     * Identifiant de la fermeture temporaire
     */
    id: number;

    /**
     * Fermeture temporaire
     */
    body: FermetureTemporaireDto
  }): Observable<FermetureTemporaireDto> {

    return this.fermetureTemporairePut$Response(params).pipe(
      map((r: StrictHttpResponse<FermetureTemporaireDto>) => r.body as FermetureTemporaireDto)
    );
  }

  /**
   * Path part for operation fermetureTemporaireDelete
   */
  static readonly FermetureTemporaireDeletePath = '/api/fermetures-temporaires-recyparcs/{id}';

  /**
   * Supprime la fermeture temporaire spécifiée.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `fermetureTemporaireDelete()` instead.
   *
   * This method doesn't expect any request body.
   */
  fermetureTemporaireDelete$Response(params: {

    /**
     * Identifiant de la fermeture temporaire
     */
    id: number;
  }): Observable<StrictHttpResponse<number>> {

    const rb = new RequestBuilder(this.rootUrl, FermeturesTemporairesRecyparcsService.FermetureTemporaireDeletePath, 'delete');
    if (params) {
      rb.path('id', params.id, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return (r as HttpResponse<any>).clone({ body: parseFloat(String((r as HttpResponse<any>).body)) }) as StrictHttpResponse<number>;
      })
    );
  }

  /**
   * Supprime la fermeture temporaire spécifiée.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `fermetureTemporaireDelete$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  fermetureTemporaireDelete(params: {

    /**
     * Identifiant de la fermeture temporaire
     */
    id: number;
  }): Observable<number> {

    return this.fermetureTemporaireDelete$Response(params).pipe(
      map((r: StrictHttpResponse<number>) => r.body as number)
    );
  }

}
